export const formatPayloadIfNeeded = (input = {}, customImages = false) => {
  if (typeof input !== 'object' || input === null) return input;

  const hasFilesKey = Object.prototype.hasOwnProperty.call(input, 'files');
  const { data, files, ...rest } = input;

  if (!hasFilesKey) {
    if (data && Object.keys(rest).length === 0) return data;
    return input;
  }

  const formData = new FormData();

  const finalData = data || rest;
  if (finalData && typeof finalData === 'object') {
    formData.append('data', JSON.stringify(finalData));
  }

  if (customImages) {
    const fileArray = Array.isArray(files) ? files : [files];

    fileArray.forEach((item) => {
      if (item && typeof item === 'object' && 'key' in item && 'file' in item && item.file?.file) {
        formData.append(item.key, item.file.file);
      }
    });
  } else {
    if (Array.isArray(files)) {
      files.forEach((file) => {
        if (file) {
          formData.append('images', file);
        }
      });
    } else {
      if (files) {
        formData.append('images', files);
      }
    }
  }

  return formData;
};
